import { EOfferDraftStatus, IDraftState } from '../../types/reducers/draft';

export const defaultState: IDraftState = {
  status: EOfferDraftStatus.initial,
};
